import { render, staticRenderFns } from "./communityElectionsDetail.vue?vue&type=template&id=2c09dbea&scoped=true"
import script from "./communityElectionsDetail.vue?vue&type=script&lang=js"
export * from "./communityElectionsDetail.vue?vue&type=script&lang=js"
import style0 from "./communityElectionsDetail.vue?vue&type=style&index=0&id=2c09dbea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c09dbea",
  null
  
)

export default component.exports